import type { VAxios } from '../../define/axios/Axios';

// 参数接口
export interface GetImageTypeParams {
  imgUrl: string;
  intelligent?: boolean;
  points?: {
    type: string;
    x: number;
    y: number;
  }[];
  uploadAddress: {
    accessKeyId?: string;
    accessKeySecret?: string;
    bucketName?: string;
    endpoint?: string;
    folder?: string;
    securityToken?: string;
  };
}

export interface MattingJobParams {
  canvas?: boolean;
  imgHash?: string;
  imgUrl: string;
  intelligent?: boolean;
  points?: {
    type: string;
    x: number;
    y: number;
  }[];
  refine?: boolean;
  uploadAddress: {
    accessKeyId?: string;
    accessKeySecret?: string;
    bucketName?: string;
    endpoint?: string;
    folder?: string;
    ltDataInfo?: string;
    securityToken?: string;
  };
}

/**
 * 抠图 相关接口
 */
export const createApi = (defHttp: VAxios) => ({
  // 同步抠图
  syncMatting: (params: { id: string | number; url: string }) =>
    defHttp.post({ url: `/aiad/creations/${params.id}/matting?url=${params.url}` }),

  // 模特抠图
  modelMatting: (params: { id: string | number; url: string }) =>
    defHttp.post({ url: `/aiad/creations/${params.id}/model/matting?url=${params.url}` }),

  // 同步抠图
  matting: (params: GetImageTypeParams) => defHttp.post({ url: `/editor/matting`, params }),

  // 异步抠图
  mattingJob: (params: MattingJobParams) => defHttp.post({ url: `/editor/matting/jobs`, params }),
  // 轮询结果
  getMattingRes: (id: number) => defHttp.get({ url: `/editor/matting/jobs/${id}` }),
});
